import React from "react";
import { Col, Image, Row } from "react-bootstrap";
import "./AllOrder.scss";

const AllOrder = ({ order }) => {
  return (
    <div className="border p-2 my-3">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <p className="text-primary">Order Id: {order?._id}</p>
          <small>
            Date: {`${new Date(order?.createdAt).toLocaleString()}`}
          </small>
        </div>
        <p
          className={`status_parent ${
            order?.status === "processing" && "text-primary"
          } ${order?.status === "cancelled" && "text-danger"} ${
            order?.status === "delivered" && "text-success"
          }`}
        >
          {order?.status}
        </p>
      </div>
      {order?.products?.map((orderData) => (
        <Row key={orderData?._id} className="mt-4">
          <Col xs={4} md={2}>
            <Image
              src={`${process.env.REACT_APP_IMAGE_URL}${orderData?.product?.images?.[0]?.filename}`}
              fluid
            />
          </Col>
          <Col xs={6} md={8}>
            <p className="order_name">{orderData?.product?.name}</p>
            <small>Model: {orderData?.product?.model}</small>
          </Col>
          <Col xs={2} md={2}>
            <div className="d-flex align-items-center flex-column mt-0">
              <p>Qty</p>
              <p>{orderData?.quantity}</p>
            </div>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default AllOrder;
